module.exports = __webpack_public_path__ + "static/IHK_Schwaben_logo-075392d7fd76800f1613e7d1c21dd750.webp";